<template>
  <div class="input-adapter-check-list">
    <vux-check-list
      :options="localOptions"
      :title="title"
      :max="isMultiple ? 9999 : 1"
      v-model="localValue"
      @on-change="_onChange"
    />
  </div>
</template>

<script>
  import VuxCheckList from 'vux/src/components/checklist'

  export default {
    name: 'InputAdapterCheckList',

    props: {
      title: {},
      options: {},
      isMultiple: {},
      value: {},
      cbs: {}
    },

    data () {
      let localOptions = this.options

      // { /// fix IT
      //   "option": "A",
      //   "subTitle": "没有经常咳痰",
      //   "score": 0
      // }

      // TODO: ----
      localOptions = localOptions.map(rawOption => {
        return {
          key: rawOption.subCode,
          value: `<strong>${rawOption.subTitle}</strong>`
        }
      })

      return {
        localValue: this.value,
        localOptions
      }
    },

    created () {
      this.$watch('valueStr', text => {
        this.cbs && this.cbs.setResponseValue(text || '未设置')
      }, {
        immediate: true
      })

      this.$watch('localValue', (val) => {
        this.cbs && this.cbs.syncLocalInputValue(val)
      }, {
        immediate: true
      })
    },

    methods: {
      getValue () {
        return this.localValue
      },

      _onChange () {
        if (this.isMultiple) {
          return
        }

        this.$nextTick(() => {
          const valueSelected = Array.isArray(this.localValue) ? !!this.localValue.length : this.localValue

          if (valueSelected && this.cbs) {
            this.cbs.tryNextCardItem()
          }
        })
      }
    },

    computed: {
      valueStr () {
        // TODO: support multiple
        let values = Array.isArray(this.localValue) ? this.localValue : (!this.localValue ? [] : [this.localValue])
        let out = ''

        values.forEach((v, i) => {
          this.localOptions.some((o) => {
            if (o.key === v) {
              out += `- ${o.value} <br>`
              return true
            }
          })
        })

        return out
      }
    },

    components: {
      VuxCheckList
    }
  }
</script>

<style lang="scss">
  .input-adapter-check-list {
    padding-top: 5px;

    .weui-cells_checkbox {
      &:before {
        display: none;
      }

      .weui-cell__hd {
        font-size: 1em;
      }

      .weui-check_label {
        line-height: 1em;
      }

      .weui-cell__bd {
        /*overflow: hidden;*/

        img {
          max-width: 70%;
          display: block;
        }
      }
    }
  }
</style>
